<template>
  <div class="container-xxl vh-100">
    <div v-if="!loading">
      <div class="row m-2">
        <div class="col-12 mt-3">
          <h1 class="py-3">Welcome to Theme Park Buddy!</h1>
          <p>
            Explore real-time wait times for your favourite attractions at Walt Disney World and Universal Parks & Resorts.<br>
            Simply choose your park below, browse the magical adventures, and add your favourites to create your own enchanted wait time list.
          </p>
          <p class="small">powered by <a href="https://queue-times.com/">Queue-Times.com</a></p>
        </div>
      </div>
      <!-- card looping through the companies -->
      <div class="row justify-content-center mt-4 mb-4">
        <div class="col-12 col-sm-6" v-for="land in lands">
          <router-link :to="{ name: 'land', params: { companySlug: land.slug }}">
            <div class="card homepage-card mb-3">
                <h3 class="pt-4 p-3 text-start">{{ land.name }}</h3>
                <div class="bar">
                  <div class="emptybar"></div>
                  <div class="filledbar"></div>
                </div>
            </div>
          </router-link>
        </div>
      </div>
      <!-- button that will scroll you back to the top -->
      <button class="back-top" @click="scrollTop()" v-if="scY > 700">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-chevron-up" viewBox="0 0 16 16">
          <path fill-rule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"/>
        </svg>
      </button>
    </div>
    <div v-else class="text-center">
      <div role="status" class="spinner-border text-center mt-4"></div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import PageNotFound from "@/views/PageNotFound.vue";
import {DotLottieVue} from "@lottiefiles/dotlottie-vue";

export default {
  name: 'Lands',
  components: {
    PageNotFound,
    DotLottieVue
  },

  data() {
    return {
      lands: {},
      loading: true,
      scY: 0
    }
  },
  mounted() {
    this.load();
    window.addEventListener('scroll', this.handleScroll);
  },
  methods: {
    load() {
      axios.get('/api/parks.json').then(response => {
        this.lands = response.data;
        // console.log(this.lands);
        this.loading = false;
        this.lands.reverse();

        // removing all non Disney companies - reason for doing this is so that if I want to expand again to other companies
        // the structure will allow for it easily as I am using the slugs to determine the parks within each company.
        const companiesToRemove = [1,3,4,5,6,7,8,9,10,11,13,14,15,16,17,18,19,21,22,23,24,25];
        this.lands = this.lands.filter(function(land) {
          return land && land.id && !companiesToRemove.includes(land.id);
        });

        // If only removing one company from the data, can use splice below - but its better to filter on the array as above
        // This was used when only removing the National Museum from the list as its not a theme park

        // const indexToRemove = 2;
        // this.lands.splice(indexToRemove, 1);

        // replacing spaces in the company names with dashes for a clean slug. Also making lower case.
        this.lands.forEach(function (land) {
          land.slug = land.name.replace(/ /g, '-').replace(/\(/g, '').replace(/\)/g, '').replace(/&/g, 'and').toLowerCase();
        });

      }).catch(error => {
        console.error(error,'unable to retrieve the list of lands');
      });
    },

    // scroll button to appear after timeout - timeout set within v-if statement above
    handleScroll () {
      if (this.scTimer) return;
      this.scTimer = setTimeout(() => {
        this.scY = window.scrollY;
        clearTimeout(this.scTimer);
        this.scTimer = 0;
      }, );
    },
    // scroll to top when clicking the button
    scrollTop() {
      window.scrollTo(0, 0)
    }
  }
}
</script>
